import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';
import { useAppDispatch } from '../../store';
import { addLocations } from '../../store/mobileSlice';

interface SearchLocationProps {
  data: string[];
  handlePopupSelected: (key: string, value: boolean) => void;
}

const SearchLocation: React.FC<SearchLocationProps> = ({ data, handlePopupSelected }) => {
  const dispatch = useAppDispatch();

  return (
    <>
      {data.map((list, index) => (
        <List key={index} dense disablePadding>
          <ListItem component="div" disablePadding>
            <ListItemButton
              onClick={() => {
                dispatch(addLocations(list));
                handlePopupSelected('locations', false);
              }}>
              <ListItemText primaryTypographyProps={{ fontSize: 18 }} primary={list} />
            </ListItemButton>
          </ListItem>
          <Divider light />
        </List>
      ))}
    </>
  );
};

export default SearchLocation;
